import React from 'react';
import { AccordionBody as BSAccordionBody } from 'react-bootstrap';

export default function AccordionBody({
  children,
  className = '',
  id = undefined,
}: {
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  className?: string;
  // eslint-disable-next-line react/require-default-props
  id?: string | undefined;
}) {
  return (
    <BSAccordionBody className={className} id={id}>
      {children}
    </BSAccordionBody>
  );
}
